import React, { useState, useEffect } from 'react';

const WebsitePopup = ({ onClose, onSave, media }) => {
    const [name, setName] = useState('');
    const [url, setUrl] = useState('');
    const [duration, setDuration] = useState(10); // Default duration in seconds
    const [behavior, setBehavior] = useState('Center');
    const [mediaId, setMediaId] = useState(null); 
    
    useEffect(() => {
        if (media) {
            setName(media.name);
            setUrl(media.text);
            setMediaId(media.id);
            setDuration(media.duration);
            setBehavior(media.behavior || 'Center'); // Default to 'Center'
        }
    }, [media]);

    const handleSave = () => {
        onSave(name, url, duration, media?.id || null);
    };

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <h2>{media ? 'Edit Website' : 'Add Website'}</h2>
                <div className="form-group">
                    <label>Name:</label>
                    <input type="text" className="form-control input-style" value={name} onChange={(e) => setName(e.target.value)} />
                </div>
                <div className="form-group">
                    <label>Website URL:</label>
                    <input type="text" className="form-control input-style" value={url} onChange={(e) => setUrl(e.target.value)} />
                </div>
                <div className="form-group">
                    <label>Duration (seconds):</label>
                    <input type="number" className="form-control input-style" value={duration} onChange={(e) => setDuration(parseInt(e.target.value))} />
                </div>                
                <div className="form-buttons">
                    <button className='btn btn-success' onClick={handleSave}>Save</button> &nbsp;
                    <button className='btn btn-primary' onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default WebsitePopup;
